import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProblemsAPI } from "../../../api/problems";

export default function ProblemCreate() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "",
    description: "",
    status: "open",
    is_public: true,
  });
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();

    if (!form.title.trim()) {
      setError("Title is required");
      return;
    }

    try {
      const problem = await ProblemsAPI.create(form);
      navigate(`/helpdesk/problems/${problem.id}`);
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="max-w-2xl">
      <h1 className="text-xl font-bold mb-4">Create Problem</h1>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="text"
          value={form.title}
          onChange={(e) =>
            setForm({ ...form, title: e.target.value })
          }
          placeholder="Problem title"
          className="w-full border rounded p-2"
        />

        <textarea
          value={form.description}
          onChange={(e) =>
            setForm({ ...form, description: e.target.value })
          }
          placeholder="Description"
          className="w-full border rounded p-2"
          rows={5}
        />

        <select
          value={form.status}
          onChange={(e) =>
            setForm({ ...form, status: e.target.value })
          }
          className="w-full border rounded p-2"
        >
          <option value="open">Open</option>
          <option value="monitoring">Monitoring</option>
          <option value="resolved">Resolved</option>
        </select>

        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={form.is_public}
            onChange={(e) =>
              setForm({ ...form, is_public: e.target.checked })
            }
          />
          Public problem
        </label>

        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          Create Problem
        </button>
      </form>
    </div>
  );
}